var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.791,
    height: 7.538,
    viewBox: "0 0 12.791 7.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M5.589.335.335,5.589A1.141,1.141,0,0,0,1.949,7.2L6.4,2.761,10.843,7.2a1.141,1.141,0,0,0,1.614-1.614L7.2.335A1.14,1.14,0,0,0,5.589.335Z",
    transform: "translate(12.791 7.538) rotate(180)",
    fill: "#2f4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.54a24b2f224d05431260ed130e40b3f2.svg";
export { ForwardRef as ReactComponent };